import { render, staticRenderFns } from "./OrganizationType.vue?vue&type=template&id=407e0a70&scoped=true&"
import script from "./OrganizationType.vue?vue&type=script&lang=js&"
export * from "./OrganizationType.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationType.vue?vue&type=style&index=0&id=407e0a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407e0a70",
  null
  
)

export default component.exports